 <div class="card flex justify-center">
            <p-popover #op>
                <ng-template #content>
                    <div class="p-3">
                        För att räkna om alla medlemmar för en institution, <br>ange institutionens id och klicka på <br>"Räkna om alla medlemsavgifter för vald institution".<br>Instituionens id får du fram genom att<br>gå till institutionens vy - <br>uppe i url-adressen kan du nu se det <br>institutions-id som systemet använder sig av.
                    </div>
                </ng-template>
            </p-popover>
            <p-button (click)="op.toggle($event)"><i class="fa fa-info-circle"></i></p-button>
</div>
